import styled from 'styled-components'

export default styled.div`
  margin-bottom: 190px;

  @media screen and (min-width: 300px) and (max-width: 767px) {
    margin-top: 20px;
    margin-bottom: 55px;
  }
  .hero-banner-background-mobile {
    display: none;
  }
  .uppercase {
    text-transform: uppercase;
    display: block;
  }

  .hero {
    &-tag {
      margin-top: 16px;
      display: block;
      color: #4951ea;
      font-family: 'Open Sans';
      font-size: 20px;
      font-weight: bold;
      line-height: 27px;
      margin-top: 32px;
    }
    &-title {
      color: #333333;
      font-family: 'Poppins', sans-serif;
      font-size: 50px;
      font-weight: bold;
      line-height: 76px;
      margin: 0;
      > span {
        color: #ff7201;
      }
      .auto-title-color {
        color: #5a5ee2;
      }
    }
    &-desc {
      margin: 5px 0;
      color: #555555;
      font-family: 'Open Sans';
      font-size: 18px;
      line-height: 29px;
      width: 95%;
    }
    &-banner {
      position: relative;
      padding-top: 110px;
      @media screen and (min-width: 1440px) {
        padding-top: 130px;
      }
      @media screen and (min-width: 320px) and (max-width: 756px) {
        padding-top: 80px;
      }
      &--background {
        width: 71%;
        display: flex;
        position: absolute;
        right: 0;
        @media screen and (min-width: 1440px) and (max-width: 1600px) {
          width: 73%;
        }
        @media screen and (min-width: 1600px) and (max-width: 1900px) {
          width: 72%;
        }
        @media screen and (min-width: 320) and (max-width: 1140px) {
          width: 81%;
        }
      }
      &--people {
        display: block;
        position: absolute;
        top: 103px;
        right: 180px;
        @media screen and (min-width: 1440px) {
          right: 180px;
        }
      }
    }
    &-seo {
      margin: 0;
      font-weight: normal;
      color: #555555;
      font-family: 'Open Sans';
      font-size: 18px;
    }
    &-sub {
      margin-top: 20px;
      .massage-color {
        color: #ff7400;
        display: block;
      }
      .fix-color {
        color: #3e88dd;
        display: block;
      }
      .clean-color {
        color: #6391be;
        display: block;
      }
      .auto-color {
        color: #888888;
        display: block;
      }
    }
  }

  @media screen and (min-width: 300px) and (max-width: 767px) {
    .hero-tag {
      margin-top: 10px;
    }
    .hero-banner--background {
      display: none;
    }

    .hero-banner--people {
      position: relative;
      top: unset;
      right: unset;
      width: 100%;
      margin-top: 100px;
    }

    .container-hero-banner {
      width: 100%;
    }

    .hero-banner {
      padding-top: 20px;
    }

    .hero-banner-content {
      max-width: 100%;
      flex-basis: unset;
    }

    @media screen and (max-width: 479px) {
      .hero-banner-content {
        .breadcrumb {
          display: none;
        }
      }
    }
  }
  @media screen and (min-width: 320px) and (max-width: 1023px) {
    .hero-banner-content {
      .breadcrumb {
        display: none;
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    .hero-banner-content {
      .breadcrumb {
        display: none;
      }
    }
    .hero-title {
      font-size: 32px;
      line-height: 35px;
    }

    .hero-banner--background {
      width: 45%;
      display: none;
    }

    .hero-banner--people {
      right: 0;
      width: 60%;
    }

    .hero-desc {
      font-size: 15px;
    }
  }

  @media screen and (min-width: 300px) and (max-width: 768px) {
    .hero-title {
      font-size: 22px;
      line-height: 35px;
    }

    .hero-banner {
      padding-top: 15px;
    }

    .hero-banner--background {
      display: none;
    }

    .hero-banner--people {
      position: relative;
      top: 0;
      right: 0;
      margin-top: 65px;
      width: 320px;
      margin-left: auto;
      margin-right: auto;
    }

    .width-reset {
      width: unset;
    }

    .width-reset .col-xs-6.col-md-6.col-lg-6 {
      flex-basis: unset;
      max-width: 100%;
    }
  }

  @media screen and (min-width: 300px) and (max-width: 400px) {
    .hero-banner {
      padding-top: 75px;
    }
    .hero-banner-background-mobile {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
    }
  }
`
